import { MaskitoOptions } from '@maskito/core';
import { maskitoDateOptionsGenerator } from '@maskito/kit';

export const fieldName = {
  CARD_NUMBER: 'cardNumber',
  CARDHOLDER: 'cardholder',
  EXPIRATION_DATE: 'expirationDate',
  SECURE_CODE: 'secureCode',
  EMAIL: 'email',
} as const;

export const expiredDateMask = maskitoDateOptionsGenerator({
  mode: 'mm/yy',
  separator: '/',
});

export const nameMask: MaskitoOptions = {
  mask: /^[a-z'.-\s]*$/i,
};

export const emailMask: MaskitoOptions = {
  mask: /^[a-z0-9._%+-@-]*$/i,
};
